import { Point } from 'pixi.js'
import Layer from '@/scripts/canvas/Layer'
import { getRandomFloat, getRandomInt } from '@/scripts/utils/math'
import SmokeStream from './SmokeStream'

export function addSmoke(layer: Layer, rects: { x: number; y: number; w: number; h: number }[], tints: number[]): void {
  const selectedRects = [...rects].sort(() => Math.random() - 0.5).slice(0, 4)

  for (const rect of selectedRects) {
    const p = new Point(rect.x + rect.w / 2, rect.y + rect.h / 2)
    const tint = tints[getRandomInt(0, tints.length - 1)]
    layer.addExtra(new SmokeStream(p, getRandomFloat(0.2, 0.3), 60, tint))
  }
}
